import app from '#app/app'
import { appLayout } from '#app/init_app_layout.svelte.ts'
import { addRoutes } from '#app/lib/router'
import { commands, reqres } from '#app/radio'
import type { GroupBoardProps } from '#groups/components/group_board.svelte'
import { getGroupBySlug, mainUserIsGroupMember, serializeGroup, type SerializedGroup } from '#groups/lib/groups'
import type { GroupSlug } from '#server/types/group'
import { mainUser } from '#user/lib/main_user'
import { showUsersHome } from '#users/users'
import { getUserGroups } from './lib/groups_data.ts'

export default {
  initialize () {
    addRoutes({
      '/g(roups)/:id(/)': 'showGroupProfile',
      '/g(roups)/:id/inventory(/)': 'showGroupInventory',
      '/g(roups)/:id/lists(/)': 'showGroupListings',
      '/g(roups)/:id/settings(/)': 'showGroupBoardFromSlug',
      '/g(roups)(/)': 'showNetworkLayout',

      // Legacy redirections
      '/network/groups/create(/)': 'showCreateGroupLayout',
      '/network/groups/settings/:id(/)': 'showGroupBoardFromSlug',
    }, controller)

    if (mainUser) getUserGroups()
  },
}

const controller = {
  showGroupProfile (slug: GroupSlug) {
    return showUsersHome({ group: slug })
  },
  showGroupInventory (slug: GroupSlug) {
    return showUsersHome({ group: slug, profileSection: 'inventory' })
  },
  showGroupListings (slug: GroupSlug) {
    return showUsersHome({ group: slug, profileSection: 'listings' })
  },
  // Named showGroupBoardFromSlug and not showGroupSettingsFromSlug
  // as GroupSettings are a child component of GroupBoard
  showGroupBoardFromSlug (slug: GroupSlug) {
    const pathname = `groups/${slug}/settings`
    if (reqres.request('require:loggedIn', pathname)) {
      return showGroupBoardFromSlug(slug)
    }
  },

  async showCreateGroupLayout () {
    const { default: CreateGroup } = await import('#groups/components/create_group.svelte')
    appLayout.showChildComponent('modal', CreateGroup)
    commands.execute('modal:open', 'medium')
  },

  showNetworkLayout () {
    commands.execute('show:inventory:network')
  },
} as const

async function showGroupBoardFromSlug (slug: GroupSlug) {
  try {
    const group = await getGroupBySlug(slug)
    await showGroupBoard(group)
  } catch (err) {
    commands.execute('show:error', err)
  }
}

export async function showGroupBoard (group: SerializedGroup, options: Omit<GroupBoardProps, 'group'> = {}) {
  try {
    if (mainUserIsGroupMember(group)) {
      const serializedGroup = serializeGroup(group)
      const { default: GroupBoard } = await import('#groups/components/group_board.svelte')
      appLayout.showChildComponent('main', GroupBoard, {
        props: {
          group: serializedGroup,
          ...options,
        },
      })
      app.navigate(serializedGroup.settingsPathname)
    } else {
      controller.showGroupInventory(group.slug)
    }
  } catch (err) {
    commands.execute('show:error', err)
  }
}
